import { FlowContext } from 'src/lib/flow';
import { FlowPage } from 'src/lib/flow/FlowPage';
import { FlowQuestion } from 'src/lib/flow/FlowQuestion';

export function isEnabled({
  answers,
  inputContext: { inApp, homebuilderIdentifier, hasHomebuilderSalesAssociate },
}: FlowContext) {
  // if user should not see this flow, or they are in app
  // then disable page
  if (inApp) {
    return false;
  }

  // if the user has answered the working with home builder question
  // only show this page if that is true
  const workingWithBuilder = answers['seller.working_with_home_builder'];
  if (typeof workingWithBuilder == 'boolean') {
    return workingWithBuilder;
  }

  // if workingWithBuilder does not have an answer (it's uindefined or null) then
  // fallback to check if we've set a homebuilderIdentifier and only show this
  // question if we do not yet have a sales associate
  return !!homebuilderIdentifier && !hasHomebuilderSalesAssociate;
}

const homebuilderDetailsPage: FlowPage = {
  slug: () => 'home-builder-details',
  title: ({ customer: { yourOrYourClients } }) =>
    `Please tell us more about ${yourOrYourClients} homebuilder`,
  autoAdvance: () => false,
  isEnabled,
  questions: (): FlowQuestion[] => [
    {
      key: 'seller.home_builder_email',
      label: 'Sales associate email (Optional)',
      type: 'email',
      optional: true,
      placeholder: 'you@example.com',
    },
    {
      key: 'seller.home_builder_community',
      label: "Homebuilder's community name (Optional)",
      type: 'single_line',
      optional: true,
      placeholder: 'Community name',
    },
  ],
};

export default homebuilderDetailsPage;
